export default "__VITE_ASSET__RdtJ14WJ__"